import { defineStore } from 'pinia';

export interface ObjectiveToDuplicate {
    id: number;
    name: string;
    category: { code: string };
    turnover: { expected: { currency: string; amount: string | number } };
    period: { duration: string; date_start: string; date_end: string };
    assignee: { type: string; id: number | null };
    refinements: Array<{
        period: { duration: string; date_start: string; date_end: string };
        turnover: { expected: { currency: string; amount: string | number } };
    }>;
    item?: { id: number; name: string };
    item_category?: { id: number };
    [key: string]: unknown;
}

export interface ObjectivesListingState {
    objectiveToDuplicate: ObjectiveToDuplicate | null;
}

export const useObjectivesListingStore = defineStore('objectivesListing', {
    state: (): ObjectivesListingState => ({
        objectiveToDuplicate: null,
    }),
});
